import { loadHelpCenterLandingPageData } from '@aboutyou/legacy-shared/src/pages/HelpCenter/loadHelpCenterPageData'
import { cdnImageUrl } from 'helpers/image'
import { FetchProps } from 'helpers/redial'
import { report } from 'helpers/reporter'

export default {
  fetch: async ({ store, service }: FetchProps) => {
    try {
      const [landingPageData, [headerImageLarge, headerImageSmall]] =
        await Promise.all([
          loadHelpCenterLandingPageData(
            service.helpCenter,
            store.localeStore.locale,
          ),
          service.staticImages.requestByContext([
            'help-center-teaser-desktop',
            'help-center-teaser-mweb',
          ]),
        ])

      store.helpCenterLandingPage.reset({
        ...landingPageData,
        sections: landingPageData.sections ?? [],
        highlightArticles: landingPageData.highlightArticles ?? [],
        highlightQuestions: landingPageData.highlightQuestions ?? [],
        headerImageLarge: headerImageLarge
          ? cdnImageUrl(headerImageLarge.hash, {
              width: 2000,
            })
          : '',
        headerImageSmall: headerImageSmall
          ? cdnImageUrl(headerImageSmall.hash, {
              width: 800,
            })
          : '',
      })
      if (!headerImageLarge || !headerImageSmall) {
        report('HelpCenter landing page teaser images missing', {
          headerImageLarge: headerImageLarge ? 'available' : 'null',
          headerImageSmall: headerImageSmall ? 'available' : 'null',
          locale: store.localeStore.locale,
        })
      }
    } catch (error) {
      report('failed to load data for help center landing page', { error })
    }
  },
}
